export enum SunlabsCaseVariant {
  ECONOMY = "ECONOMY",
  LIVE = "LIVE",
  PROFESSIONAL = "PROFESSIONAL",
  HEAVY = "HEAVY",
  TYPE = "TYPE",
  SPECIAL = "SPECIAL",
}
